import MentionTooltip from 'vcomponents/richtext/customoptions/MentionTooltip.vue';

const MentionMixin = {
    methods: {
        buildMention(content) {
            const idStaff = $(content).is('[data-mention-id]') // old mentions had this attribute
                ? $(content).attr('data-mention-id')
                : $(content).attr('data-id');
            const MentionClass = Vue.extend(MentionTooltip);
            const mentionInstance = new MentionClass({
                parent: this,
                propsData: {
                    fullName: content.textContent.replace('@', ''),
                    idStaff: +idStaff,
                    userLoggedId: this.$store.getters['user/getUser'].id,
                    text: content.textContent,
                },
            });
            mentionInstance.$mount();
            return mentionInstance;
        },
    },
};

export default MentionMixin;
